import { useState } from 'react'

export function useStoredWidth(key: string, fallback: number, min = 360, maxRatio = 0.8) {
  const [w, setW] = useState(() => {
    const s = localStorage.getItem(key)
    return s ? Math.max(min, Math.min(Number(s), Math.round(window.innerWidth * maxRatio))) : fallback
  })
  const set = (n: number) => {
    setW(n)
    localStorage.setItem(key, String(n))
  }
  return [w, set] as const
}
